import { useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import "@/App.css";
import Hero from "./components/Hero";
import ScissorsReveal from "./components/ScissorsReveal";
import Services from "./components/Services";
import About from "./components/About";
import Booking from "./components/Booking";
import ManageBooking from "./components/ManageBooking";
import InstagramStrip from "./components/InstagramStrip";
import LoyaltyBanner from "./components/LoyaltyPromo";
import LoyaltyPopup from "./components/LoyaltyPopup";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import AdminPage from "./pages/AdminPage";
import OwnerCancelPage from "./pages/OwnerCancelPage";
import LoyaltyCardPage from "./pages/LoyaltyCardPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_SERVICES = [
  { id: "taglio", name: "Taglio Capelli", price: 13, duration: 20 },
  { id: "taglio_bambini", name: "Taglio Bambini (fino a 10 anni)", price: 10, duration: 20 },
  { id: "barba", name: "Barba", price: 8, duration: 20 },
  { id: "taglio_barba", name: "Taglio + Barba", price: 20, duration: 30, popular: true },
  { id: "taglio_barba_shampoo", name: "Taglio + Barba + Shampoo", price: 23, duration: 40 },
  { id: "shampoo", name: "Shampoo Rigenerante", price: 5, duration: 5 },
  { id: "sobraciglia", name: "Sopracciglia con Filo", price: 5, duration: 10 },
  { id: "sopracciglia_rasoio", name: "Sopracciglia con Rasoio a Mano", price: 5, duration: 10 },
  { id: "crema_viso", name: "Trattamento Crema Viso", price: 5, duration: 10 },
];

const Landing = () => {
  const [services, setServices] = useState(FALLBACK_SERVICES);

  useEffect(() => {
    const touch = window.matchMedia("(pointer: coarse)").matches;
    let lenis = null;
    let rafId;
    if (!touch) {
      lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
      window.__lenis = lenis;
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    }
    axios.get(`${API}/services`).then((r) => setServices(r.data)).catch(() => {});
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Hero />
      <LoyaltyBanner />
      <ScissorsReveal />
      <Services services={services} />
      <About />
      <Booking services={services} />
      <ManageBooking />
      <InstagramStrip />
      <Contact />
      <Footer />
      <ChatWidget />
      <LoyaltyPopup />
    </>
  );
};

function App() {
  return (
    <div className="bg-[#F7F2EC] text-[#1A1416] min-h-screen antialiased">
      <Toaster theme="light" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/annulla/:id" element={<OwnerCancelPage />} />
          <Route path="/tessera/:token" element={<LoyaltyCardPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
